module.exports = __webpack_public_path__ + "static/media/aicte-udaan-ack.946b0fd2.png";